import React, {useRef} from 'react'
import {useInputValue} from '@modifi/plugin-forms'
import {State, TRADE_PARTNER_COUNTRY_CODE, TRADE_PARTNER_STATE} from '@modifi/plugin-onboarding'

export const CustomState: React.FC<{}> = props => {
  const {value: countryCode} = useInputValue({name: TRADE_PARTNER_COUNTRY_CODE})
  const {value: state} = useInputValue({name: TRADE_PARTNER_STATE})

  const disableRef = useRef(true)
  // if there's no state value then making input always active so that
  // typing in a single letter won't make it disabled again
  // @ts-expect-error property is a string
  if (!state && ['US', 'CA'].includes(countryCode?.toUpperCase())) {
    disableRef.current = false
  }

  return (
    <State
      {...props}
      // @ts-expect-error property is a string
      required={['US', 'CA'].includes(countryCode?.toUpperCase())}
      {...(disableRef.current ? {} : {disabled: false})}
    />
  )
}
